export default {
  en: {
    snack: {
      generic_error: 'Something went wrong',
    },
    confirm_dialog_msg: {
      default: 'Are you sure?',
    },
    actions: {
      settings: 'Edit',
      delete: 'Delete',
      cancel: 'Cancel',
    },
  },
};
